import { Grid } from '@material-ui/core';
import ChevronCardButton from 'components/ChevronCardButton';
import { pushTo } from 'helpers/routes';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedFaq } from 'store/global/actions';

export interface ChevronCardButtonListType {
  items: any;
  backgroundColor?: string;
  borderColor?: string;
  direction?: any;
  borderRadius?: string;
  spacing?: any;
  deleteHoverBorder?: Boolean;
  mdGrid?: any;
  smGrid?: any;
  setDetailsPageBreadcrumbsPath?: Function;
}

const ChevronCardButtonList = ({
  items,
  backgroundColor,
  borderColor,
  direction,
  borderRadius,
  spacing,
  deleteHoverBorder,
  mdGrid,
  smGrid,
  setDetailsPageBreadcrumbsPath,
}: ChevronCardButtonListType) => {
  const dispatch = useDispatch();
  return (
    <Grid container direction={direction} spacing={spacing}>
      {items.map((item: any, index: number) => (
        <Grid xs={12} sm={smGrid} md={mdGrid} item key={index}>
          <ChevronCardButton
            backgroundColor={backgroundColor}
            borderColor={item?.isNew ? '#F9AA01' : borderColor}
            clickHandler={
              /* istanbul ignore next */ () => {
                if (item.BreadcrumbsPath) {
                  setDetailsPageBreadcrumbsPath &&
                    setDetailsPageBreadcrumbsPath(item.BreadcrumbsPath);
                } else if (item.payload) {
                  dispatch(item.payload);
                } else if (item.isFaq) {
                  dispatch(
                    setSelectedFaq({
                      id: item.id,
                      code: item.code,
                    }),
                  );
                } else if (item.onPress) {
                  item.onPress();
                  return;
                }
                item.action ? item.action() : pushTo(item.path, item.props);
              }
            }
            borderRadius={borderRadius}
            item={item}
            index={index}
            deleteHoverBorder={deleteHoverBorder}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ChevronCardButtonList;
